import { ReactNode } from 'react';
import { Badge } from '@/shared/ui/badge';

type Props = {
    children?: ReactNode;
    count?: number;
};
export const BottomPanelTabIconWrapper = ({ children, count = 0 }: Props) => {
    return (
        <div className="bottom-panel__icon-wrapper">
            {children}
            {!!count && (
                <Badge shape="rounded" variant="error" className="bottom-panel__badge">
                    {count}
                </Badge>
            )}
        </div>
    );
};
